import { z } from 'zod';

const postUploadResultSchema = z.object({
  id: z.string().optional(),
  field_name: z.string(),
  file_name: z.string(),
  success: z.boolean(),
  error: z.string().optional(),
});

const postUploadResponseSchema = z.object({
  results: z.array(postUploadResultSchema),
  message: z.string(),
});

export type PostUploadResult = z.infer<typeof postUploadResultSchema>;
export type PostUploadResponse = z.infer<typeof postUploadResponseSchema>;

export const userDocuments = {
  postUploadFiles: {
    path: 'user-documents/v1/files',
    schema: postUploadResponseSchema,
  },
};
